module.exports = __webpack_public_path__ + "img/img_G1.1.2.aed90efb.png";